import React, { memo } from 'react';
import { InventoryEntities } from 'client/data/models/inventory';
import { WarrantyShortOriginalDescriptionLine } from 'site-modules/shared/components/inventory/warranty-module/warranty-item/warranty-short-original-description-line/warranty-short-original-description-line';
import { WarrantyComments } from 'site-modules/shared/components/inventory/warranty-module/warranty-item/warranty-comments/warranty-comments';
import {
  isWarrantyItemEligible,
  warrantyConditionsUsedCopyProviders,
} from 'site-modules/shared/utils/inventory/warranty';
import { ExpiredWarrantyWarningIcon } from 'site-modules/shared/components/inventory/warranty-module/expired-warranty-warning-icon/expired-warranty-warning-icon';
import { ViewMoreAccordionItem } from 'site-modules/shared/components/inventory/accordion/view-more-accordion-item/view-more-accordion-item';
import { WarrantyShortDescriptionLine } from 'site-modules/shared/components/inventory/warranty-module/warranty-item/warranty-short-description-line/warranty-short-description-line';

export const WarrantyItemUsed = memo(props => {
  const { warrantyItem, vinData } = props;

  const isWarrantyEligible = isWarrantyItemEligible(vinData, warrantyItem);

  return (
    <div>
      <div className="d-flex align-items-center mb-1">
        {!isWarrantyEligible && (
          <span className="me-0_25">
            <ExpiredWarrantyWarningIcon size="small" />
          </span>
        )}
        <h3 className="heading-5 mb-0">{warrantyItem.warrantyType}</h3>
      </div>
      <WarrantyShortDescriptionLine
        label="Est. Remaining*"
        value={warrantyConditionsUsedCopyProviders.getConditionsCopy(vinData, warrantyItem)}
      />
      <div className="mt-0_25">
        <WarrantyShortOriginalDescriptionLine warrantyItem={warrantyItem} />
      </div>
      <ViewMoreAccordionItem
        id={warrantyItem.id}
        className="mt-1"
        collapsedSummary="View details"
        expandedSummary="Hide details"
        trackingId="view_details"
        trackingValue={warrantyItem.warrantyType}
      >
        <div className="mt-1">
          <WarrantyComments warrantyItem={warrantyItem} />
        </div>
      </ViewMoreAccordionItem>
    </div>
  );
});

WarrantyItemUsed.propTypes = {
  warrantyItem: InventoryEntities.WarrantyItem.isRequired,
  vinData: InventoryEntities.InventoryVin.isRequired,
};

WarrantyItemUsed.displayName = 'WarrantyItemUsed';
